import { render, staticRenderFns } from "./LabelNormalMain.vue?vue&type=template&id=4ade739a&scoped=true&"
import script from "./LabelNormalMain.vue?vue&type=script&lang=js&"
export * from "./LabelNormalMain.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormalMain.vue?vue&type=style&index=0&id=4ade739a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade739a",
  null
  
)

export default component.exports